var _path, _path2, _path3, _path4, _path5, _g, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSk30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2869 19.9186C4.52505 19.5606 3.89713 19.2713 3.89713 18.6882C3.89713 18.2421 4.25463 17.9177 4.95792 17.9177C5.21611 17.9177 5.43 17.9457 5.64898 17.9875C5.76306 18.0063 5.8863 18.0236 5.98713 18.0236C6.60181 18.0236 6.94912 17.6575 7.17981 16.9603L7.27556 16.6741C7.17727 16.6349 6.17199 16.1934 4.86065 16.1934C2.77625 16.1934 1.67421 17.5317 1.67574 18.922C1.67574 19.6217 1.89523 20.131 2.23847 20.5302C2.68204 21.0451 3.31148 21.3827 3.90019 21.6694C4.7588 22.0921 5.5344 22.4038 5.5344 23.0291C5.5344 23.5842 4.96148 23.901 4.19403 23.901C3.14648 23.901 2.22931 23.3001 2.11319 23.2272L1.25 24.8452C1.40278 24.9317 2.51194 25.6376 4.3412 25.6376C6.28606 25.6371 7.75884 24.5182 7.75884 22.7985C7.75884 21.0894 6.39301 20.4543 5.2869 19.9186Z",
    fill: "#E21837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8986 20.7157L16.4293 16.3813H13.914L11.0989 20.1229H11.0566V16.3813H8.9834V25.5633H9.10664C10.0024 25.5633 11.0698 25.1477 11.0698 23.65V21.5407H11.1136L13.9833 25.4502H16.6208L12.8986 20.7157Z",
    fill: "#E21837"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5473 6.54541C15.816 6.68291 14.7339 7.34546 14.7379 8.52134C14.74 9.58569 15.6113 10.2309 15.6139 11.6273C15.6174 12.6784 15.0399 13.3858 14.4146 13.7779C14.6671 13.7545 14.9447 13.7402 15.2482 13.7402C15.8878 13.7382 16.2718 13.7988 16.2958 13.8039L19.5708 9.77819C18.6602 8.4149 17.5979 7.35717 16.5473 6.54541Z",
    fill: "#E21837"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.298 17.4121C19.7095 16.7715 19.763 15.7463 19.7971 14.7029C19.8358 13.7307 20.0385 12.9979 21.3381 12.9928C21.6259 12.9912 21.9014 13.032 22.3984 13.0305C24.3025 13.0223 25.5446 12.3648 26.3187 11.9345C24.7385 10.9262 22.431 9.89494 19.5705 9.77832C19.3846 10.3074 17.9342 14.3438 17.8237 14.6692C17.8416 14.6891 18.0952 14.9743 18.4124 15.5304C18.8804 16.2938 19.1305 16.9405 19.298 17.4121Z",
    fill: "#E21837"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3925_20008",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 4,
    width: 6,
    height: 11
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0898 4.14014H16.0837V14.1142H11.0898V4.14014Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3925_20008)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3798 14.1145C12.2158 14.1145 12.1333 14.005 12.1114 13.815C12.0906 13.6241 11.2706 6.12319 11.1484 4.98602C11.1311 4.81949 11.0899 4.51546 11.0899 4.40648C11.0883 4.2313 11.2029 4.14014 11.3379 4.14014C11.7254 4.13912 13.8388 4.63565 16.0837 6.21028C15.4374 6.39208 14.2666 7.06634 14.2717 8.46171C14.2773 9.69412 15.1588 10.374 15.1639 11.614C15.17 13.6266 12.8606 14.1135 12.3798 14.1145Z",
    fill: "#F37725"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4854 17.9457C19.5205 18.0409 19.5536 18.1209 19.5877 18.1749C19.6386 18.264 19.7054 18.3037 19.7899 18.3037C19.8413 18.3037 19.905 18.2838 19.9758 18.2518C20.1489 18.1723 26.9867 14.9854 28.018 14.5087C28.1692 14.4374 28.4509 14.3106 28.5466 14.2556C28.6418 14.2006 28.6856 14.1186 28.6856 14.0366C28.6856 13.9913 28.6719 13.9449 28.6474 13.9022C28.5191 13.6939 27.8555 12.9911 26.7489 12.2231C25.871 12.7059 24.4995 13.4561 22.4589 13.4637C21.9578 13.4647 21.8463 13.4291 21.5051 13.4326C20.509 13.4357 20.261 13.8609 20.2233 14.7358C20.2172 14.9008 20.2166 15.1229 20.2049 15.3673C20.1739 16.15 20.0822 17.2266 19.4854 17.9457Z",
    fill: "#F37725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk30);
export default __webpack_public_path__ + "static/media/SK증권-30.d7e147c6d8069195f79fd4079af81094.svg";
export { ForwardRef as ReactComponent };